import { useState } from "react";
import { Add as AddIcon } from "@mui/icons-material";

import "./styles.css";
import Button from "../Button";
import TextField from "../TextField";
import nanoid from "../../lib/nanoid";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";

interface IUrlInput {
    title?: string;
    placeholder?: string;
    disabled?: boolean;
    onAddUrl?: (url: string) => void;
}

const UrlInput: React.FC<IUrlInput> = (props: IUrlInput) => {
    const strings = useStrings();
    const [renderKey, setRenderKey] = useState<string>(nanoid());
    const [url, setUrl] = useState<string>();

    const handleChangeValue = (url: string) => {
        setUrl(url);
    }

    const handleAddUrl = () => {
        if (!Helpers.isNullOrEmpty(url)) {
            props.onAddUrl && props.onAddUrl(url);
            setRenderKey(nanoid());
            setUrl(undefined);
        }
    }

    return (
        <div className="d-flex w-100 justify-content-center">
            <div className={"fileUploader-urlInputContainer"}>
                <TextField
                    key={renderKey}
                    disabled={props.disabled}
                    label={props.title || "URL"}
                    placeholder={props.placeholder || strings.Common.ENTER_FILE_URL}
                    onChange={(event: any) => handleChangeValue(event.target.value)}
                />
                <Button
                    sx={{ mt: 3 }}
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={handleAddUrl}
                >
                    {strings.Common.ADD_NEW}
                </Button>
            </div>
        </div>
    )
}

export default UrlInput;